import type { EnvConfig } from './../../../../libs/types/src/lib/types';
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// eslint-disable @nx/enforce-module-boundaries */
import {
  Module,
  VuexModule,
  Mutation,
  Action,
  MutationAction,
} from 'vuex-module-decorators';
import $http from '../services/api';

@Module({ namespaced: true, name: 'envconfig' })
export default class RegisterTan extends VuexModule {
  private readonly urlPrefix = 'envconfig';
  private envConfig: EnvConfig = null;

  @Mutation
  setEnvConfig(config: EnvConfig) {
    this.envConfig = config;
  }

  @Action({ rawError: true })
  async loadEnvConfig() {
    const conf = await $http.get<EnvConfig>(this.urlPrefix).then((resp) => resp.data);

    this.context.commit('setEnvConfig', conf);

    return conf;
  }

  get showEnvBanner() {
    return this.envConfig?.environment?.deployment != 'production';
  }

  get activeEnvConfig(): EnvConfig {
    return this.envConfig;
  }
}
